import Vue from "vue";
import BaseProxy from "./base-proxy";

/**
 * Class AccountProxy
 */
class AccountProxy extends BaseProxy {
  /**
   * Constructor.
   *
   * @param {Object} parameters The query parameters.
   */
  constructor(parameters = {}) {
    super("/invoice-robotics-api/api", parameters);
  }

  register(payload) {
    const toast = {
      success: Vue.i18n.t("app.createSuccess")
    };
    // payload.user_name = payload.email.toLowerCase();
    return this.submit("post", `${this.endpoint}/v2/register`, payload, {
      toast,
      showDefErrMsg: true
    });
  }

  update(payload) {
    const toast = {
      success: Vue.i18n.t("app.companyInformationUpdated")
    };
    return this.submit("post", `${this.endpoint}/v2/company/update`, payload, {
      toast,
      i18nHandleErr: "error.company.update" // string này xem trong error.json
    });
  }

  connectTaxAccount(payload) {
    const toast = {
      success: Vue.i18n.t("app.connectionSuccessful")
    };
    return this.submit("post", `${this.endpoint}/cqt/account`, payload, {
      toast,
      showLoading: true,
      loadingMessage: Vue.i18n.t("app.connectingToTheTaxAuthorityAccount")
    });
  }

  updateTaxAccount(payload) {
    return this.submit(
      "post",
      `${this.endpoint}/cqt/account/update-password`,
      payload,
      {
        toast: {
          success: Vue.i18n.t("app.taxAuthorityAccountUpdated")
        }
      }
    );
  }

  checkValidTaxAccount() {
    return this.submit(
      "post",
      `${this.endpoint}/cqt/account/check-valid`,
      null,
      { allowToast: false }
    );
  }

  confirmInvoices(invoiceIds) {
    return this.submit("post", `${this.endpoint}/cqt/account/update-origin`, {
      id: invoiceIds
    });
  }

  getDetailsInvoice(payload, options = {}) {
    return this.submit(
      "post",
      `${this.endpoint}/cqt/account/get-details-invoice`,
      payload,
      { showResponseStatus: true, ...options }
    );
  }
}

export default AccountProxy;



// WEBPACK FOOTER //
// ./src/store/proxies/account-proxy.js